import React, { useMemo } from 'react'
import DataBindDropDown from 'app/shared/components/databind-dropdown/databind-dropdown'
import { useHistory } from 'react-router-dom'
import { useAppContext } from 'app/app-context/app-context'
import { useUserContext } from 'app/shared/state/user-context'

const CompaniesSelect = () => {
  const history = useHistory()

  const { currentCompanies, currentCommunity, currentCompany, isContactperson } = useAppContext()
  const { currentUser } = useUserContext()

  const companyChanged = async (_propName: string, value: any) => {
    const company = currentCompanies.find((x) => x.id === value)
    if (!company || !currentCommunity) {
      return
    }

    if (isContactperson === true && currentUser && currentUser.companyUserRoles) {
      const userRole = currentUser.companyUserRoles.find((x) => x.companyId === company.id)
      if (userRole) {
        history.push(
          `/communities/${currentCommunity.id}/companies/${company.id}/companyusers/${userRole.companyUserId}`
        )
      }
      return
    }

    history.push(`/communities/${currentCommunity.id}/companies/${company.id}`)
  }

  const dataItems = useMemo(() => {
    var items = currentCompanies.map((x) => {
      return {
        id: x.id as string | undefined,
        name: x.name,
      }
    })

    items = [{ id: undefined, name: '' }, ...items]
    return items
  }, [currentCompanies])

  if (
    currentCompanies.length <= 1 ||
    currentUser?.isGlobalAdmin ||
    (currentUser?.companyUserRoles && currentUser.companyUserRoles.length <= 1)
  ) {
    return <div></div>
  }

  return (
    <DataBindDropDown
      style={{ width: '10em' }}
      data={dataItems}
      dataText="name"
      dataValue="id"
      label="Bedrijven"
      defaultValue={currentCompany?.id || undefined}
      onChanged={companyChanged}
      propName="adminCompanies"
    />
  )
}

export default CompaniesSelect
